import React from 'react';

const InputTypeSurvey = ({showConditional}) => {
    if(!showConditional) return null

    return (
        <div>
           
        </div>
    );
};

export default InputTypeSurvey;